import { FabricObject } from 'fabric';
import { isSystemPiece } from '../../canvas/utils/canvas-pieces';

export type SubjectClassification =
  | { kind: 'video'; obj: FabricObject; videoEl: HTMLVideoElement }
  | { kind: 'falloff'; obj: FabricObject }
  | { kind: 'none' };

export function classifySubject(
  selectedObject: FabricObject | null,
  getVideo: (id: string) => HTMLVideoElement | null
): SubjectClassification {
  if (!selectedObject) return { kind: 'none' };

  const id = (selectedObject as FabricObject & { id?: string }).id;
  const videoEl = id ? getVideo(id) : null;
  if (videoEl) return { kind: 'video', obj: selectedObject, videoEl };

  if (isSystemPiece(selectedObject)) return { kind: 'none' };

  return { kind: 'falloff', obj: selectedObject };
}
